/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as NotificationDefs from './defs.defs.js'

const $nsid = 'app.bsky.notification.putPreferencesV2'

export { $nsid }

/** Set notification-related preferences for an account. Requires auth. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    chat: l.optional(
      l.ref<NotificationDefs.ChatPreference>(
        (() => NotificationDefs.chatPreference) as any,
      ),
    ),
    follow: l.optional(
      l.ref<NotificationDefs.FilterablePreference>(
        (() => NotificationDefs.filterablePreference) as any,
      ),
    ),
    like: l.optional(
      l.ref<NotificationDefs.FilterablePreference>(
        (() => NotificationDefs.filterablePreference) as any,
      ),
    ),
    likeViaRepost: l.optional(
      l.ref<NotificationDefs.FilterablePreference>(
        (() => NotificationDefs.filterablePreference) as any,
      ),
    ),
    mention: l.optional(
      l.ref<NotificationDefs.FilterablePreference>(
        (() => NotificationDefs.filterablePreference) as any,
      ),
    ),
    quote: l.optional(
      l.ref<NotificationDefs.FilterablePreference>(
        (() => NotificationDefs.filterablePreference) as any,
      ),
    ),
    reply: l.optional(
      l.ref<NotificationDefs.FilterablePreference>(
        (() => NotificationDefs.filterablePreference) as any,
      ),
    ),
    repost: l.optional(
      l.ref<NotificationDefs.FilterablePreference>(
        (() => NotificationDefs.filterablePreference) as any,
      ),
    ),
    repostViaRepost: l.optional(
      l.ref<NotificationDefs.FilterablePreference>(
        (() => NotificationDefs.filterablePreference) as any,
      ),
    ),
    starterpackJoined: l.optional(
      l.ref<NotificationDefs.Preference>(
        (() => NotificationDefs.preference) as any,
      ),
    ),
    subscribedPost: l.optional(
      l.ref<NotificationDefs.Preference>(
        (() => NotificationDefs.preference) as any,
      ),
    ),
    unverified: l.optional(
      l.ref<NotificationDefs.Preference>(
        (() => NotificationDefs.preference) as any,
      ),
    ),
    verified: l.optional(
      l.ref<NotificationDefs.Preference>(
        (() => NotificationDefs.preference) as any,
      ),
    ),
  }),
  l.jsonPayload({
    preferences: l.ref<NotificationDefs.Preferences>(
      (() => NotificationDefs.preferences) as any,
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
